import { render, staticRenderFns } from "./ConsentApprove.vue?vue&type=template&id=795b42c8&scoped=true&"
import script from "./ConsentApprove.vue?vue&type=script&lang=js&"
export * from "./ConsentApprove.vue?vue&type=script&lang=js&"
import style0 from "./ConsentApprove.vue?vue&type=style&index=0&id=795b42c8&prod&lang=css&"
import style1 from "./ConsentApprove.vue?vue&type=style&index=1&id=795b42c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b42c8",
  null
  
)

export default component.exports